import analytics from "../analytics";
import useReducerActions from "../useReducerActions";
import useActiveExperts from "./useActiveExperts";
import useFeatureState from "./useFeatureState";

const useOpenDealsModal = () => {
  const { expert } = useActiveExperts();
  const { listingId } = useFeatureState();
  const { dispatchSetModalAgent } = useReducerActions();

  return () => {
    dispatchSetModalAgent(expert);

    analytics({
      isHdp: Boolean(listingId),
      label: `be_click_deals|expert_contact_id=${expert.contact.id}‌|pro=${expert.contact.is_pro}`
    });
  };
};

export default useOpenDealsModal;
